import { CommitteeSettings } from '@/features/committee/ui/CommitteeSettings';

/**
 * §5: a page composes, it does not implement.
 */
export function CommitteeSettingsPage() {
  return <CommitteeSettings />;
}
